export default "__VITE_ASSET__DJQmljod__"